/**
 * Método que pega uma string separado por ; e transforma a string
 * em um csv para o usuário
 */
const stringToExportCSV = (fileName, csvString) => {
	var csvFile = new Blob(['\ufeff', csvString], { type: 'text/csv' })
	var downloadLink = document.createElement('a')
	downloadLink.download = `${fileName}.csv`
	downloadLink.href = window.URL.createObjectURL(csvFile)
	downloadLink.click()
}

export { stringToExportCSV }
